import { render, staticRenderFns } from "./ButtonRounded.vue?vue&type=template&id=69466141&scoped=true"
import script from "./ButtonRounded.vue?vue&type=script&lang=js"
export * from "./ButtonRounded.vue?vue&type=script&lang=js"
import style0 from "./ButtonRounded.vue?vue&type=style&index=0&id=69466141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69466141",
  null
  
)

export default component.exports